import type { TurnInput } from "./generated"
import type { ImageAttachment, UserInputContext } from "../types"

function record(value: unknown): Record<string, unknown> | null {
    return typeof value === "object" && value !== null && !Array.isArray(value) ? (value as Record<string, unknown>) : null
}

export function parseTurnInput(value: unknown): TurnInput | null {
    const parts = record(value)?.parts
    if (!Array.isArray(parts)) return null

    const parsed: TurnInput["parts"] = []
    for (const part of parts) {
        const candidate = record(part)
        if (candidate?.type === "text" && typeof candidate.text === "string") {
            parsed.push({ type: "text", text: candidate.text })
            continue
        }
        if (candidate?.type === "attachment" && typeof candidate.attachmentId === "string") {
            parsed.push({ type: "attachment", attachmentId: candidate.attachmentId })
            continue
        }
        return null
    }
    return { parts: parsed }
}

export function textTurnInput(text: string): TurnInput {
    return { parts: [{ type: "text", text }] }
}

function imageAttachmentPart(image: ImageAttachment): TurnInput["parts"][number] {
    if (!image.attachmentId) {
        throw new Error("Image turns require Nest attachment-backed images")
    }
    return { type: "attachment", attachmentId: image.attachmentId }
}

export function userInputTurnInput(input: UserInputContext): TurnInput {
    if (input.images.length === 0) return textTurnInput(input.userInput)
    const parts: TurnInput["parts"] = input.images.map(imageAttachmentPart)
    if (input.userInput.length > 0) parts.push({ type: "text", text: input.userInput })
    return { parts }
}
